import {FormattedMessage} from "react-intl";
import {useSelector} from "react-redux";

import {
  createTheme,
  ThemeProvider,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Box,
} from "@material-ui/core";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import { CustomizedTableFooter } from "../../custom/CustomizedTableFooter";
import { useStyles } from "../../../shared/styles/useStyles";
import { AppState } from "../../../redux/reducers/rootReducer";
import { UsersBody } from "./UsersBody";
import { IUserForm } from "../../../module/admin/form/IUsersForm";
import { Colors } from "../../../shared/constants/themes/Colors";
import {useEffect, useState} from "react";

const theme = createTheme({
  typography: {
    fontFamily: "Poppins",
    fontSize: 11,
  },
});

export const UsersTable = () => {
  const classes = useStyles();

  const {users} = useSelector((state: AppState) => state.users);
  const {data, value} = useSelector((state: AppState) => state.search);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(9);
  const list: IUserForm[] = users;

  const currentData: IUserForm[] = value.trim() ? data ?? [] : users;


  const count = currentData.length;
  const emptyRows = rowsPerPage - Math.min(rowsPerPage, count - page * rowsPerPage);

  const paginatedData =
    rowsPerPage > 0
      ? currentData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
      : currentData;

  return (
    <ThemeProvider theme={theme}>
      <TableContainer component={Paper}>
        {users.length <= 0 ? (
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            style={{height: 200}}
            className={classes.title}
          >
            <InfoOutlinedIcon style={{fontSize: 30, color: Colors.ACCENT}}/>
            <FormattedMessage id={"NoCreatedUsers"}/>
          </Box>
        ) : (
          <Table
            className={classes.table}
            size="small"
            style={{tableLayout: "auto"}}
            aria-label="a dense table"
          >
            <TableHead className={classes.titleTable}>
              <TableRow>
                <TableCell className={classes.titleTable}>
                  <FormattedMessage id="Name"/>
                </TableCell>
                <TableCell className={classes.titleTable}>
                  <FormattedMessage id="DocumentType"/>
                </TableCell>
                <TableCell className={classes.titleTable}>
                  <FormattedMessage id="Identification"/>
                </TableCell>
                <TableCell className={classes.titleTable}>
                  <FormattedMessage id="Email"/>
                </TableCell>
                <TableCell className={classes.titleTable} align="center">
                  <FormattedMessage id="State"/>
                </TableCell>
                <TableCell className={classes.titleTable} align="center">
                  <FormattedMessage id="RestricUser"/>
                </TableCell>
                <TableCell className={classes.titleTable} align="center">
                  <FormattedMessage id="Actions"/>
                </TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {paginatedData.map((row) => (
                <UsersBody key={row.document} {...row} />
              ))}

              {emptyRows > 0 && (
                <TableRow style={{height: 23 * emptyRows}}>
                  <TableCell colSpan={7}/>
                </TableRow>
              )}
            </TableBody>
            <CustomizedTableFooter
              count={count}
              page={page}
              rowsPerPage={rowsPerPage}
              onChangePage={(_, newPage) => setPage(newPage)}
              onChangeRowsPerPage={(e) => {
                setRowsPerPage(parseInt(e.target.value, 10));
                setPage(0);
              }}
            />
          </Table>
        )}
      </TableContainer>
    </ThemeProvider>
  );
};